import { useEffect } from 'react';

// useEffect that only runs on the first render
export function useMountEffect(effect) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
}